import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/Home";
import KVKK from "@/pages/KVKK";
import Cookies from "@/pages/Cookies";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kvkk" element={<KVKK />} />
          <Route path="/cerez-politikasi" element={<Cookies />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
